import React from 'react';

export default function RevenueWidget({
  stores = [],
  totalRevenue = 0,
  target = 0,
}) {
  const safeNumber = (val) =>
    typeof val === 'number' && !isNaN(val) ? val : 0;

  const percent =
    safeNumber(target) > 0 ? safeNumber(totalRevenue) / safeNumber(target) : 0;

  let progressColor = 'bg-green-500';
  if (percent < 0.6) progressColor = 'bg-red-500';
  else if (percent < 0.85) progressColor = 'bg-orange-400';

  const money = (value) =>
    safeNumber(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div className="bg-white rounded-2xl shadow p-4 mb-4">
      <h2 className="text-xl font-bold mb-2">Monthly Revenue</h2>
      <div className="mb-2">
        <span className="font-semibold">Total:</span> €{money(totalRevenue)}
      </div>
      <div className="mb-2">
        <span className="font-semibold">Target:</span> €{money(target)}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-4 mb-4">
        <div
          className={`${progressColor} h-4 rounded-full transition-all`}
          style={{
            width: `${Math.min(100, percent * 100)}%`,
          }}
        />
      </div>
      <div className="flex flex-col gap-2">
        {stores.map((store) => (
          <div key={store.id || store.name} className="flex justify-between">
            <span>{store.name || 'Unknown Store'}</span>
            <span>
              €
              {money(
                store.revenue ??
                  (store.Orders
                    ? store.Orders.reduce(
                        (sum, order) => sum + (order.total || 0),
                        0
                      )
                    : 0)
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
